/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.foundationModule')
.controller('ModalController', ['$element', '$scope', 'BulbModalService', ModalController]);

/**
* Controller to add global behavior across all modal dialogs via our custom modal window template.
*/
function ModalController($element, $scope, BulbModalService) {

  /**
   * Closes the top modal.
   * @param event
   */
  this.close = function (event) {
    BulbModalService.cancel(event);
  };

  /**
   * handle close key down.
   * @param evt
   */
  this.onCloseKeydown = function (event) {
    if (event.key === 'Escape') {
      this.close(event);
    }
  };

  {
    var windowClass = $element.parent().attr('window-class');
    // only asset library
    if (windowClass && windowClass.match(/(assetlibrary)|(scrollable)/)) {
      BulbModalService.initScrollableModalLayoutHandler($scope);
    }
  }
}


